import { render, staticRenderFns } from "./shopBagList.vue?vue&type=template&id=41bd42a2&scoped=true"
import script from "./shopBagList.vue?vue&type=script&lang=js"
export * from "./shopBagList.vue?vue&type=script&lang=js"
import style0 from "./shopBagList.vue?vue&type=style&index=0&id=41bd42a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bd42a2",
  null
  
)

export default component.exports